/**
 * Those are all FFs used across applications.
 *
 * @usage
 * Add a new flag starting with app name e.g. SAAS_, STORE_, LINK_
 * and also add the flag to happykit https://happykit.dev/FlectoDevAccount/flecto/flag/production
 *
 * As soon as the feature is deployed and rolled out to customers, open a
 * PR to remove it from here and parts of code that use it.
 */
export type FeatureFlags = {
  SAAS_ENABLE_BUNDLES: boolean
}

export const FeatureFlagsDefaults: FeatureFlags = {
  SAAS_ENABLE_BUNDLES: false,
}
